import {onKeyStroke, useLocalStorage} from '@vueuse/core'
import {__} from "@/Utils/index.js";

function renderDebugComponent() {

    const uiDebugBar = document.getElementById('ui-debug-bar');
    if (!uiDebugBar) {
        return;
    }

    const debugComponent = uiDebugBar.querySelector('[data-debug-form-component]') || document.createElement('div');

    if (debugEnabled.value) {
        debugComponent.title = __('Ctrl + Alt + D to disable');
        debugComponent.innerText = __('📄 Debug Forms Enabled');
        debugComponent.setAttribute('data-debug-form-component', '');
        debugComponent.className = 'rounded-full bg-black text-white text-xs px-2 py-1 color-black';

        uiDebugBar.appendChild(debugComponent);
    } else {
        if (debugComponent.parentNode) {
            debugComponent.parentNode.removeChild(debugComponent);
        }
    }
}

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    }

    return value === null || value === undefined || value === '' || value === 0 || value === false;
}

const appEnv = import.meta.env.VITE_APP_ENV;

let debugEnabled = {value: false};
if (appEnv !== 'production') {
    debugEnabled = useLocalStorage('debugFormEnabled', false);
    onKeyStroke(['ctrl', 'alt', 'd'], (e) => {
        debugEnabled.value = !debugEnabled.value;
        renderDebugComponent();
    });

    renderDebugComponent();
}

export default function debugForm(inputs, debugDefaults) {
    if (!debugEnabled.value) {
        return inputs;
    }

    for (const key in inputs) {
        if (inputs.hasOwnProperty(key) && debugDefaults.hasOwnProperty(key) && isEmpty(inputs[key])) {
            inputs[key] = debugDefaults[key];
        }
    }

    return inputs;
}
